'use client';

import React from 'react';

import Markdown from '@components/utils/Markdown';

import {
  DateContainer,
  DateHeader,
  DateLabel,
  DateSection,
  DateValue,
  Description,
  Separator,
  Wrapper,
} from './styled';
import { formatValidTourDate } from './utils';

interface TourDatesProps {
  departureDate?: string;
  arrivalDate?: string;
  departureDescription?: string;
  arrivalDescription?: string;
}

const TourDates: React.FC<TourDatesProps> = ({
  departureDate,
  arrivalDate,
  departureDescription,
  arrivalDescription,
}) => {
  const formattedDepartureDate = formatValidTourDate(departureDate);
  const formattedArrivalDate = formatValidTourDate(arrivalDate);

  if (!formattedDepartureDate && !formattedArrivalDate) return null;

  return (
    <Wrapper>
      <DateContainer>
        {formattedDepartureDate ? (
          <DateSection>
            <DateHeader>
              <DateLabel>Gidiş Tarihi</DateLabel>
              <DateValue>{formattedDepartureDate}</DateValue>
            </DateHeader>
            {departureDescription ? (
              <Description>
                <Markdown text={departureDescription} />
              </Description>
            ) : null}
          </DateSection>
        ) : null}

        {formattedDepartureDate && formattedArrivalDate ? <Separator /> : null}

        {formattedArrivalDate ? (
          <DateSection>
            <DateHeader>
              <DateLabel>Dönüş Tarihi</DateLabel>
              <DateValue>{formattedArrivalDate}</DateValue>
            </DateHeader>
            {arrivalDescription ? (
              <Description>
                <Markdown text={arrivalDescription} />
              </Description>
            ) : null}
          </DateSection>
        ) : null}
      </DateContainer>
    </Wrapper>
  );
};

export default TourDates;
